import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { UserDto } from 'src/api/FiretrolApiClient';
import { BasicButton } from 'src/design/atoms/BasicButton';
import { Modal } from 'src/design/molecules/Modal';

interface IRestoreArchivedUserModalProps {
  archivedUser: UserDto | null;
  opened: boolean;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const RestoreArchivedUserModal: React.FC<
  IRestoreArchivedUserModalProps
> = ({ archivedUser, opened, loading, onConfirm, onClose }) => (
  <Modal
    size="md"
    title="Restore archived user?"
    opened={opened}
    onClose={onClose}
    actions={[
      <BasicButton key="restore" loading={loading} onClick={onConfirm}>
        Restore User
      </BasicButton>,
    ]}
  >
    {archivedUser && (
      <Text>
        {archivedUser.fullName} ({archivedUser.email}) is archived. Inviting
        this email restores their existing profile, history, and permissions.
        The values entered in this form will not be applied.
      </Text>
    )}
  </Modal>
);
